import { Paper, Stack, Avatar, Typography, Grid, Divider, Button, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { alert } from "src/services/alert";
import StringUtil from "src/utils/StringUtil";
import FormDialog from "../common/FormDialog";
import { asyncRequest } from "src/services/network";

const OrderDetailDialog = ({ open, onClose, order }) => {
  const [deliverySN, setDeliverySN] = useState(order.deliverySN);
  const [editing, setEditing] = useState(false);

  if (!order.id) return null;

  async function handleEditDeliverySN() {
    if (!editing) return setEditing(true);

    const { msg } = await asyncRequest({
      path: "/store/order/setDeliverySN",
      data: {
        orderSN: order.orderSN,
        deliverySN,
      },
      complete() {},
    });

    setEditing(false);
  }

  return (
    <FormDialog title="订单详情" open={open} onClose={onClose} onConfirm={onClose}>
      <Stack sx={{ minWidth: 600 }}>
        {/* <Typography variant="body1">
          收货信息
        </Typography> */}
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography variant="body2">收件人：{order.receiverName}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">联系电话：{order.receiverMobile}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">收货地址：{order.receiverAddress}</Typography>
          </Grid>
        </Grid>

        <Divider sx={{ marginY: 2 }} />

        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography variant="body2">订单编号：{order.orderSN}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">商品总数：1</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">商品总价：{StringUtil.toFixed2(order.totalPrice)}</Typography>
          </Grid>
        </Grid>

        <Divider sx={{ marginY: 2 }} />

        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography variant="body2">物流单号：{order.deliverySN}</Typography>

            <Stack direction="row">
              <TextField autoComplete="false" autoFocus value={deliverySN} fullWidth onChange={(e) => setDeliverySN(e.target.value)} disabled={!editing} size="small" placeholder="请输入物流单号" />
              <Button variant="text" onClick={handleEditDeliverySN}>
                {editing ? "保存" : "修改"}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </FormDialog>
  );
};

export default OrderDetailDialog;
